import { FormattedMessage } from "react-intl";
import GoogleMap from "component/googleMap";
import Mailto from "component/shared/mailto";
import { LabelLangString } from "component/LabelLang/label-lang";
import { TRANSLATION_KEYS } from "constants/TranslationConstant";

export default function HeadQuarterSection({
  dir,
  currentLocale,
  headQuarter,
  headQuarterLocations,
}) {
  return (
    <>
      <div className="col-12 col-lg-12">
        <div className="contact">
          <h3>
            <FormattedMessage id="head-quarter" />
          </h3>
        </div>
      </div>
      <div className="col-12 col-lg-7">
        <div className="row">
          <div className="col-12 col-lg-5">
            <div className="item-cont">
              <img
                loading="lazy"
                src={process.env.PUBLIC_URL + "/image/cont1.svg"}
                alt="item-img"
              />
              <span>
                {headQuarter?.address ? (
                  LabelLangString({
                    id: "address",
                    currentLocale,
                    defaultValue: headQuarter.address,
                    translations:
                      headQuarter[TRANSLATION_KEYS.REGIONAL_OFFICE],
                  })
                ) : (
                  <FormattedMessage id="data-not-found" />
                )}
              </span>
            </div>
          </div>
          <div className="col-12 col-lg-7">
            <div className="item-cont">
              <img
                loading="lazy"
                src={process.env.PUBLIC_URL + "/image/cont2.svg"}
                alt="item-img"
              />
              <span
                dir="ltr"
                className={dir === "rtl" ? "text-end" : "text-start"}
              >
                {headQuarter?.phoneNumber ? (
                  headQuarter.phoneNumber
                ) : (
                  <FormattedMessage id="data-not-found" />
                )}
              </span>
            </div>
            <div className="item-cont">
              <img
                loading="lazy"
                src={process.env.PUBLIC_URL + "/image/cont3.svg"}
                alt="item-img"
              />
              {headQuarter?.mail ? (
                <Mailto email={headQuarter.mail}>{headQuarter.mail}</Mailto>
              ) : (
                <span>
                  <FormattedMessage id="data-not-found" />
                </span>
              )}
            </div>
          </div>
        </div>
      </div>
      <div className="col-12"></div>
      <div className="col-12 col-lg-6">
        <div className="map-c mb-5">
          <GoogleMap
            zoom={15}
            isGovernateSelected={true}
            defaultCenterPoint={[27.442248, 29.770797]}
            geoLocationData={headQuarterLocations}
          />
        </div>
      </div>
    </>
  );
}
